import DifferenceIcon from '@mui/icons-material/Difference';
import { useEffect, useState } from "react";
import { ToolsPanelToggleButton } from "../../../screens/positions-and-orders/controls";
import {
    usePortfolioSelection,
    usePortfolioManagement,
    usePortfolioProfile,
} from "../../../shared/contexts/portfolio-context/components/PortfolioContextProvider";

export function DeltaValuesVisibilityToggle() {
    const {
        selectedPortfolio,
    } = usePortfolioSelection();
    const {
        saveSelectedPortfolio,
    } = usePortfolioManagement();
    const {
        updateSelectedPortfolio,
    } = usePortfolioProfile();

    const initialValue = selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
        ? selectedPortfolio.portfolioSettings.showDeltaValues
        : false;

    const [value, setValue] = useState<boolean>(initialValue);

    useEffect(() => {
        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null)
            setValue(selectedPortfolio.portfolioSettings.showDeltaValues);
    }, [selectedPortfolio]);

    const onChange = async () => {
        const newValue = !value;

        setValue(newValue);

        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null) {
            selectedPortfolio.portfolioSettings.showDeltaValues = newValue;
            updateSelectedPortfolio();
            saveSelectedPortfolio();
        }
    }
    
    return (
        <ToolsPanelToggleButton
            isActivated={value}
            setIsActivated={onChange}
            tooltipTextWhenActivated="Hide delta values"
            tooltipTextWhenDeactivated="Show delta values"
        >
            <DifferenceIcon
                sx={{
                    height: '18px',
                    width: '18px',
                }}
            /> 
        </ToolsPanelToggleButton>
    )
}